import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const Header = styled(Accordion.Header) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
`;
export const Trigger = styled(Accordion.Trigger) `
  padding: ${theme.spacing.xs} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};
  color: ${theme.semantic.foreground.primary};
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border: none;
    box-shadow: inset 0 0 0 ${pxToRem(2)} ${theme.semantic.focus.ring};
  }

  &:hover {
    background-color: ${theme.semantic.surface.sunken};
  }

  [data-icon='falcon'] {
    transition: ${theme.motion.duration.normal};
  }

  &[data-panel-open] {
    [data-icon='falcon'] {
      transform: rotate(90deg);
    }
  }
`;
export const ActionsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;
